<div class="flex-row justify-content-space-between align-items-center mb-10">
  <button
    class="drawer-action-button"
    mat-button
    (click)="back()"
  >
    <mat-icon>arrow_back</mat-icon> <span class="button-label">Cancel</span>
  </button>

  @if (isSaving) {
    <mat-spinner [diameter]="20" class="m-10"></mat-spinner>
  } @else {
    <button mat-icon-button
            (click)="save()"
            [disabled]="!canSave()"
            matTooltip="Save"
    >
      <mat-icon>save</mat-icon>
    </button>
  }
</div>

<mat-form-field>
  <mat-label>Observation Type Group</mat-label>
  <mat-select
    [(ngModel)]="observationTypeGroupId"
    (ngModelChange)="typeGroupChanged($event)"
  >
    @for (typeGroup of observationTypeGroups; track $index) {
      <mat-option [value]="typeGroup.id">{{ typeGroup.name }}</mat-option>
    }
  </mat-select>
</mat-form-field>

@if (observationTypeGroupId) {
  <mat-form-field>
    <mat-label>Observation Type</mat-label>
    <mat-select
      [(ngModel)]="observationTypeId"
      (ngModelChange)="typeChanged($event)"
    >
      @for (type of observationTypes; track $index) {
        <mat-option [value]="type.id">{{ type.title }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (observationTypeId && selectedType) {
    <p>
      Click anywhere on the map to drop a <b>{{ selectedType.title }}</b> observation
    </p>
  }
}


